var map = {
	"./4th Conference - 1-1 Meetings.jpg": 9065,
	"./4th Conference - Karaoke Night.jpg": 7190,
	"./4th Conference - Registration Photos.jpg": 0,
	"./4th Conference - Welcome Cocktail.jpg": 9943,
	"./dummy_4th.jpg": 8118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3514;